import { ClassificationDetection } from '../snapshot/classificationDetection';
import { ClassificationDetectionMatch } from '../snapshot/classificationMatch';
import { DsiAnnotation } from './dsiAnnotation';
import { z } from 'zod';

export const DsiAdditionalClassificationsTracking = z.object({
    snapshotsLabeled: z.number().int(),
    snapshotsReviewed: z.number().int(),
});
export type DsiAdditionalClassificationsTracking = z.infer<typeof DsiAdditionalClassificationsTracking>;

export const DsiAdditionalClassificationsRating = z.enum([
    'unprocessed',
    // Human-made labels are 100% correct
    'correct-human',
    // Automatic labels are 100% correct
    'correct-auto',
    // There are zero boxes, and that is 100% correct
    'correct-zero-boxes',
    // Neither human nor auto labels are 100% correct
    'incorrect-both',
]);
export type DsiAdditionalClassificationsRating = z.infer<typeof DsiAdditionalClassificationsRating>;

export const DsiAdditionalClassificationsFeedback = z.enum([
    // one or more boxes are missing
    'boxes-missing',
    // one or more boxes are where no object is
    'boxes-surplus',
    // one or more boxes have the wrong class
    'boxes-wrong-class',
    // one or more boxes have inaccurate edges
    'boxes-inaccurate-edges',
]);
export type DsiAdditionalClassificationsFeedback = z.infer<typeof DsiAdditionalClassificationsFeedback>;

export const DsiAdditionalClassificationsReview = z.object({
    rating: DsiAdditionalClassificationsRating,
    feedback: DsiAdditionalClassificationsFeedback.array().nullish(),
});
export type DsiAdditionalClassificationsReview = z.infer<typeof DsiAdditionalClassificationsReview>;

export const DsiAdditionalClassifications = z.object({
    detections: ClassificationDetection.array(),
    match: ClassificationDetectionMatch,
    review: DsiAdditionalClassificationsReview,
    correctAnnotations: DsiAnnotation.array().nullish(),
});
export type DsiAdditionalClassifications = z.infer<typeof DsiAdditionalClassifications>;
